<template>
  <RevInfoBlock
    :icon="IconWarning"
    :title="i18n(translations.infoBlockTitle)"
    variant="warning"
  >
    <div class="space-y-16">
      <p class="body-2">{{ i18n(translations.infoBlockContent) }}</p>

      <RevButton
        size="small"
        to="https://www.assistance.bouyguestelecom.fr/s/contact"
        variant="primary"
      >
        {{ i18n(translations.infoBlockCta) }}
      </RevButton>
    </div>
  </RevInfoBlock>
</template>

<script lang="ts" setup>
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevInfoBlock } from '@ds/components/InfoBlock'
import { IconWarning } from '@ds/icons/IconWarning'

import translations from './BouyguesAssistanceInfoBlock.translations'

const i18n = useI18n()
</script>
